// import external dependencies

import "jquery"

// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/_wowjs.js"

var $kimWindow = jQuery(window);
var $kimDocument = jQuery(document);
var $kimBody = jQuery("body");
var kimScrollWidth = 0;

function kimGetScrollWidth() {
  var div = document.createElement("div");

  div.style.overflowY = "scroll";
  div.style.width = "50px";
  div.style.height = "50px";
  div.style.visibility = "hidden";
  div.style.position = "absolute";
  div.style.top = "0px";
  div.style.left = "-900px";

  $kimDocument.ready(() => {
    document.body.appendChild(div);

    kimScrollWidth = div.offsetWidth - div.clientWidth;

    document.body.removeChild(div);
  });
}

function windowWidth() {
  var e = window,
    a = "inner";
  var windowWidth;

  if (!("innerWidth" in window)) {
    a = "client";
    e = document.documentElement || document.body;
  }

  windowWidth = e[a + "Width"];

  return windowWidth;
}

function windowHeight() {
  var e = window,
    a = "inner";
  var windowHeight;

  if (!("innerHeight" in window)) {
    a = "client";
    e = document.documentElement || document.body;
  }

  windowHeight = e[a + "Height"];

  return windowHeight;
}

function kimHandleButtonsFocus() {
  $(document).on("mouseleave", "button, a", function() {
    if (!$(this).hasClass("sl-next") && !$(this).hasClass("sl-prev")) {
      this.blur();
    }
  });
}

function kimHandleAnchorLinks() {
  $kimDocument.on("click", "a", function(event) {

    var $link = $(this);
    var href = $link.attr("href");
    var hashPosition = -1;

    if (href) {
      hashPosition = href.indexOf("#");
    }

    if (hashPosition !== -1) {
      var url = href.substring(0, hashPosition);
      var windowUrl = window.location.href;
      var windowHashPosition = window.location.href.indexOf("#");

      if (windowHashPosition !== -1) {
        windowUrl = window.location.href.substring(0, windowHashPosition);
      }

      if (!url || (windowUrl === url)) {

        var hash = href.substring(hashPosition + 1);
        var $target = $("#" + hash);

        if ($target.length) {
          event.preventDefault();

          var targetOffset = $target.offset().top;
          var $header = $("#header");

          if ($header.length) {
            targetOffset -= $header.innerHeight();
          }

          $("html, body").animate({ scrollTop: targetOffset }, 700);
        }
      }
    }
  });
}

function kimFixPlaceholders() {
  var $inputs = $("input,textarea");

  if ($inputs.length) {
    $inputs.each(function() {
      $(this).data("holder", $(this).attr("placeholder"));

      $(this).focusin(function() {
        $(this).attr("placeholder", "");
      });

      $(this).focusout(function() {
        $(this).attr("placeholder", $(this).data("holder"));
      });
    });
  }
}

function kimFixFrames() {
  var $frames = $(".kim-article iframe, .kim-entry iframe");

  if ($frames.length) {
    $frames.each(function() {
      var $this = $(this);

      if (
        (!$this.attr("id") ||
          ($this.attr("id") && $this.attr("id").indexOf("gform") === -1)) &&
        !$this.hasClass("kim-reviews-frame")
      ) {
        var $frameParent = $this.parent();
        var width = $this.attr("width");
        var height = $this.attr("height");
        var padding = "";
        var sizes = "";

        if (width && height) {
          if (width === "100%") {
            width = 1300;
            height = 730;
          } else if (height === "100%" && width !== "100%") {
            height = 730;
            width = height * 1.78;
          } else {
            width = parseInt(width, 10);
            height = parseInt(height, 10);
          }

          padding = (height / width) * 100;
          sizes =
            ' style="max-width: ' +
            width +
            "px; " +
            "max-height: " +
            height +
            'px;"';
        }

        if ($frameParent.prop("tagName") !== "P") {
          if (padding) {
            padding = ' style="padding-bottom: ' + padding + '%;"';
          }

          $this.wrap(
            '<div class="kim-iframe-wrap-outer"' +
            (sizes ? sizes : "") +
            '><p class="kim-iframe-wrap"' +
            padding +
            "></p></div>"
          );
        } else if (!$frameParent.hasClass("kim-iframe-wrap")) {
          $frameParent.addClass("kim-iframe-wrap");

          if (padding) {
            $frameParent.css("padding-bottom", padding + "%");
          }

          $frameParent.wrap(
            '<div class="kim-iframe-wrap-outer"' +
            (sizes ? sizes : "") +
            "></div>"
          );
        }
      }
    });
  }
}

function kimCloseNavMenu($menuSection, $bodyOverlay, $headerOverlay) {
  if ($menuSection.css('left')) {
    if (windowWidth() >= 992) {
      $menuSection.css("left", "");
      $menuSection.removeClass("active");
    } else {
      $menuSection.animate({ left: "-310px" }, 200, () => {
        $menuSection.css("left", "");
        $menuSection.removeClass("active");
      });
    }
  }


  if ($kimBody.hasClass("kim-body--noscroll")) {
    $kimBody.removeClass("kim-body--noscroll");

    if (!("ontouchstart" in document.documentElement)) {
      $kimBody.css("padding-right", "");
    }
  }

  if (
    $bodyOverlay.length &&
    $bodyOverlay.hasClass("kim-body__overlay--active")
  ) {
    $bodyOverlay.animate({ opacity: "0" }, 200, () => {
      $bodyOverlay.css("opacity", "");
      $bodyOverlay.removeClass("kim-body__overlay--active");
    });
  }

  if (
    $headerOverlay.length &&
    $headerOverlay.hasClass("kim-header__overlay--active")
  ) {
    $headerOverlay.animate({ opacity: "0" }, 200, () => {
      $headerOverlay.css("opacity", "");
      $headerOverlay.removeClass("kim-header__overlay--active");
    });
  }
}

function kimInitNavigation() {
  var $menuSection = $("#kim-header__part--menu");
  var $header = $("#header");
  var $heroSectionInner = $("#kim-hero__inner");

  if ($header.length) {
    var headerHeight = 0;
    var scrolledHeight = 0;
    var $headerBg = $("#kim-header__bg");

    $kimWindow.on("load resize scroll", event => {
      // var screenWidth = windowWidth();
      var koefficient = 0.2;

      /* if (screenWidth <= 567) {
        koefficient = 0.2;
      } */

      scrolledHeight = $kimWindow.scrollTop();
      headerHeight = $header.outerHeight(true);

      if (
        (event.type === "load" || event.type === "resize") &&
        $heroSectionInner.length
      ) {
        $heroSectionInner.css("padding-top", headerHeight);
      }

      if ($headerBg.length) {
        if (scrolledHeight >= koefficient * headerHeight) {
          if (!$headerBg.hasClass("active")) {
            $headerBg.addClass("active");

            if (!$headerBg.hasClass("visible")) {
              setTimeout(() => {
                $headerBg.addClass("visible");
              }, 100);
            }
          }
        } else {
          if ($headerBg.hasClass("visible")) {
            $headerBg.removeClass("visible");

            if ($headerBg.hasClass("active")) {
              setTimeout(() => {
                $headerBg.removeClass("active");
              }, 100);
            }
          }
        }
      }
    });

    $kimWindow.resize().scroll();
  }

  if ($menuSection.length) {
    var $bodyOverlay = $("#kim-body__overlay");
    var $headerOverlay = $("#kim-header__overlay");
    var $dropdownLinks = $(".kim-navbar__link--dropdown-toggle");

    if ($dropdownLinks.length) {
      $dropdownLinks.each(function() {
        var $link = $(this);
        var href = $link.attr('href');
        var hashIndex = href.indexOf('#');
        var hash = '';

        if (hashIndex !== -1) {
          hash = href.substr(hashIndex + 1);
        }

        if ((hashIndex !== 0) || hash) {
          var $linkParent = $link.parent();
          var $dropdownMenu = $linkParent.children(
            ".kim-navbar__dropdown-menu"
          );

          if ($dropdownMenu.length) {
            var $clone = $dropdownMenu
              .children()
              .first()
              .clone();
            var $cloneLink = $clone.children().first();

            if ($clone.hasClass("kim-navbar__item--dropdown")) {
              $clone.removeClass("kim-navbar__item--dropdown");
              $clone.removeClass("dropdown");

              $cloneLink.removeClass("kim-navbar__link--dropdown-toggle");
              $cloneLink.removeClass("dropdown-toggle");
            }

            $clone.addClass("kim-navbar__item--parent-clone");
            $clone.attr("id", $linkParent.attr("id") + "-clone");

            $cloneLink.addClass("kim-navbar__link--parent-clone");
            $cloneLink.attr("id", $link.attr("id") + "-clone");
            $cloneLink.attr("href", $link.attr("href"));
            $cloneLink.removeData("toggle");
            $cloneLink.removeAttr("data-toggle");
            $cloneLink.removeAttr("aria-haspopup");
            $cloneLink.removeAttr("aria-expanded");
            $cloneLink.html($link.html());

            $clone.prependTo($dropdownMenu);
          }
        }
      });

      $(".dropdown-menu .kim-navbar__link--dropdown-toggle").on(
        "click",
        function() {
          if (!$menuSection.hasClass("hoverable")) {
            var $link = $(this);
            var $parent = $link.offsetParent(".dropdown-menu");
            var $subMenu = $link.next(".dropdown-menu");

            if (!$subMenu.hasClass("show")) {
              $link
                .parents(".dropdown-menu")
                .first()
                .find(".show")
                .removeClass("show");
            }

            $subMenu.toggleClass("show");

            $link.parent("li").toggleClass("show");

            $link
              .parents("li.nav-item.dropdown.show")
              .on("hidden.bs.dropdown", function() {
                $(".dropdown-menu .show").removeClass("show");
              });

            if (!$parent.parent().hasClass("navbar-nav")) {
              $link.next().css({
                top: $link[0].offsetTop,
                left: $parent.outerWidth() - 4,
              });
            }

            return false;
          }
        }
      );

      $kimDocument.on(
        "mouseenter",
        ".hoverable .kim-navbar__item--dropdown",
        function() {
          var $menuItem = $(this);
          var $subMenu = $menuItem.children(".dropdown-menu").first();

          if (
            !$menuItem.hasClass("kim-navbar__item--level-0") &&
            !$menuItem.hasClass("kim-navbar__item--level-1")
          ) {
            $subMenu = $menuItem.find(".dropdown-menu");
          }

          if (!$menuItem.hasClass("show")) {
            $menuItem.addClass("show");
            $subMenu.addClass("show");
            $menuItem
              .children(".kim-navbar__link")
              .first()
              .attr("aria-expanded", "true");
          }
        }
      );

      $kimDocument.on(
        "mouseleave",
        ".hoverable .kim-navbar__item--dropdown",
        function() {
          var $menuItem = $(this);

          if ($menuItem.hasClass("show")) {
            $menuItem.removeClass("show");
            $menuItem
              .children(".kim-navbar__link")
              .first()
              .attr("aria-expanded", "false");

            if (
              $menuItem.hasClass("kim-navbar__item--level-0") ||
              $menuItem.hasClass("kim-navbar__item--level-1") ||
              $menuItem.hasClass("kim-navbar__item--level-2")
            ) {
              var $subMenu = $menuItem.find(".dropdown-menu");

              $subMenu.removeClass("show");
            }
          }
        }
      );

      $(".dropdown").on("hidden.bs.dropdown", function() {
        // hide any open menus when parent closes
        $(".dropdown-menu.show").removeClass("show");
      });
    }

    $kimDocument.on(
      "click",
      "#kim-navbar__toggler--open",
      function() {
        if ($menuSection.hasClass("active")) {
          kimCloseNavMenu($menuSection, $bodyOverlay, $headerOverlay);
        } else {
          if (!$kimBody.hasClass("kim-body--noscroll")) {
            $kimBody.addClass("kim-body--noscroll");

            if (!("ontouchstart" in document.documentElement)) {
              $kimBody.css("padding-right", kimScrollWidth);
            }
          }

          $menuSection.animate({ left: "0" }, 200, () => {
            $menuSection.addClass("active");
          });

          if ($bodyOverlay.length) {
            $bodyOverlay.addClass("kim-body__overlay--active");
            $bodyOverlay.animate({ opacity: "1" }, 200);
          }

          if ($headerOverlay.length) {
            $headerOverlay.addClass("kim-header__overlay--active");
            $headerOverlay.animate({ opacity: "1" }, 200);
          }
        }
      }
    );

    $kimDocument.on("click", "#kim-navbar__toggler--close", function() {
      if ($menuSection.hasClass("active")) {
        kimCloseNavMenu($menuSection, $bodyOverlay, $headerOverlay);
      }
    });

    $kimDocument.keyup(function(e) {
      if (e.which == 27 && $menuSection.hasClass("active")) {
        kimCloseNavMenu($menuSection, $bodyOverlay, $headerOverlay);
      }
    });

    $kimDocument.on("click", function(e) {
      var $target = $(e.target);

      if (
        ($target.hasClass("kim-navbar__link") &&
          $menuSection.hasClass("active")) ||
        (!$target.hasClass(".kim-navbar__toggler--open") &&
          !$target.hasClass(".kim-navbar__toggler--close") &&
          !$target.hasClass("kim-header__part--menu") &&
          !$target.parents(".kim-header__part--menu").length &&
          $menuSection.hasClass("active"))
      ) {
        kimCloseNavMenu($menuSection, $bodyOverlay, $headerOverlay);
      }
    });

    $kimWindow.on("load resize", () => {
      kimCloseNavMenu($menuSection, $bodyOverlay, $headerOverlay);

      if (
        windowWidth() >= 992 &&
        !("ontouchstart" in document.documentElement) &&
        !$menuSection.hasClass("hoverable")
      ) {
        $menuSection.addClass("hoverable");

        if ($dropdownLinks.length) {
          $dropdownLinks.removeData("toggle");
          $dropdownLinks.removeAttr("data-toggle");
        }
      } else if (
        (windowWidth() < 992 || "ontouchstart" in document.documentElement) &&
        $menuSection.hasClass("hoverable")
      ) {
        $menuSection.removeClass("hoverable");

        if ($dropdownLinks.length) {
          $dropdownLinks.attr("data-toggle", "dropdown");
          $dropdownLinks.data("toggle", "dropdown");
        }
      }
    });

    $kimWindow.on("load", () => {
      var $activeLinks = $(".kim-navbar__link--active");

      if ($activeLinks.length) {
        $activeLinks.each(function(){
          var $this = $(this);
          var linkHref = $this.attr("href");
          var linkHashIndex = -1;
          var $linkAncestors;

          if (window.location.hash) {
            linkHashIndex = linkHref.indexOf(window.location.hash);

            if (linkHashIndex === -1) {
              $linkAncestors = $this.parents(".kim-navbar__item--ancestor");

              $this.removeClass("kim-navbar__link--active");
              $this.parent().removeClass("kim-navbar__item--active");
            }
          } else {
            linkHashIndex = linkHref.indexOf("#");

            if ((linkHashIndex !== -1) && (linkHref !== "#")) {
              $linkAncestors = $this.parents(".kim-navbar__item--ancestor");

              $this.removeClass("kim-navbar__link--active");
              $this.parent().removeClass("kim-navbar__item--active");
            }
          }

          if ($linkAncestors && $linkAncestors.length) {
            $linkAncestors.each(function(){
              var $item = $(this);

              $item.removeClass("kim-navbar__item--ancestor");
              $item.children(".kim-navbar__link--ancestor").removeClass("kim-navbar__link--ancestor");
            });
          }
        });
      }
    });
  }
}

function kimInitSlider() {
  var $slider = $("#kim-slider .kim-slider__inner");

  if ($slider.length) {
    var $sliderItems = $slider.find(".kim-slider__item");
    var $sliderLoader = $("#kim-slider .kim-slider__loader");
    var $nextArrow = $("#kim-slider .kim-slider__nav-button--next");
    var $prevArrow = $("#kim-slider .kim-slider__nav-button--prev");

    $slider.on('init', function(){
      var $header = $("#header");

      if ($header.length) {
        var $sliderItemBgs = $slider.find(".kim-slider__item-bg");
        var $sliderItemDesktopBgs = $slider.find(".kim-slider__item-bg--desktop");
        var $sliderItemContainers = $slider.find(".kim-slider__item-container");
        var headerHeight = $header.outerHeight(true);
        var screenWidth = windowWidth();

        $kimWindow.on("resize", () => {
          var currentScreenWidth = windowWidth();
          headerHeight = $header.outerHeight(true);

          if ((currentScreenWidth < 568) && (screenWidth >= 568)) {
            $sliderItems.css("padding-top", headerHeight);
            $sliderItemBgs.css("top", (headerHeight * -1));
            $sliderItemDesktopBgs.css("top", (headerHeight * -1));
            $sliderItemBgs.css("margin-bottom", (headerHeight * -1));
            $sliderItemDesktopBgs.css("margin-bottom", (headerHeight * -1));
            $sliderItemContainers.css("padding-top", '');
          } else {
            if ((currentScreenWidth >= 568) && (screenWidth < 568)) {
              $sliderItems.css("padding-top", '');
              $sliderItemBgs.css("top", '');
              $sliderItemDesktopBgs.css("top", "");
              $sliderItemBgs.css("margin-bottom", '');
              $sliderItemDesktopBgs.css("margin-bottom", "");
              $sliderItemContainers.css("padding-top", headerHeight);
            }

            if (currentScreenWidth >= 568) {
              $sliderItemContainers.css("padding-top", headerHeight);
            }
          }

          screenWidth = currentScreenWidth;
        });

        $kimWindow.on("load", () => {
          headerHeight = $header.outerHeight(true);

          if (screenWidth < 568) {
            $sliderItems.css("padding-top", headerHeight);
            $sliderItemBgs.css("top", (headerHeight * -1));
            $sliderItemDesktopBgs.css("top", (headerHeight * -1));
            $sliderItemBgs.css("margin-bottom", (headerHeight * -1));
            $sliderItemDesktopBgs.css("margin-bottom", (headerHeight * -1));
            $sliderItemContainers.css("padding-top", '');
          } else {
            $sliderItems.css("padding-top", '');
            $sliderItemBgs.css("top", '');
            $sliderItemDesktopBgs.css("top", "");
            $sliderItemBgs.css("margin-bottom", '');
            $sliderItemDesktopBgs.css("margin-bottom", "");
            $sliderItemContainers.css("padding-top", headerHeight);
          }

          setTimeout(() => {
            if ($sliderLoader.length) {
              $sliderLoader.addClass('kim-slider__loader--loaded');
            }

            $slider.addClass('kim-slider__inner--visible');
          }, 500);
        });

        if (screenWidth < 568) {
          $sliderItems.css("padding-top", headerHeight);
          $sliderItemBgs.css("top", (headerHeight * -1));
        } else {
          $sliderItemContainers.css("padding-top", headerHeight);
        }
      }
    });

    $slider.slick({
      infinite: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 7000,
      dots: false,
      mobileFirst: true,
      zIndex: 10,
      rows: 0,
      nextArrow: ($nextArrow.length ? $nextArrow : ""),
      prevArrow: ($prevArrow.length ? $prevArrow : ""),
    });
  }
}

function kimInitGallerySlider($element, $arrowsBlock, startSlide = 0) {
  $element.slick({
    slidesToShow: 1,
    rows: 1,
    slidesPerRow: 1,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 568,
      settings: {
        rows: 2,
        slidesPerRow: 1,
        slidesToScroll: 1,
      },
    }, {
      breakpoint: 768,
      settings: {
        rows: 2,
        slidesPerRow: 2,
        slidesToScroll: 1,
      },
    }],
    initialSlide: startSlide,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 5000,
    mobileFirst: true,
    adaptiveHeight: false,
    zIndex: 1,
    lazyLoad: "ondemand",
    dots: false,
    arrows: (!!$arrowsBlock.length),
    appendArrows: ($arrowsBlock.length ? $arrowsBlock : ""),
    nextArrow: ($arrowsBlock.length ? "<button type=\"button\" class=\"kim-gallery__nav-button kim-gallery__nav-button--next\"></button>" : ""),
    prevArrow: ($arrowsBlock.length ? "<button type=\"button\" class=\"kim-gallery__nav-button kim-gallery__nav-button--prev\"></button>" : ""),
  });
}

function kimResizeCurrentFancybox(id, action = 'close') {
  var $fancyboxSlide = $(id).closest('.fancybox-slide');

  if ($fancyboxSlide.length) {
    var $fancyboxImages = $fancyboxSlide.find(".kim-gallery__item-img--fancybox");
    var $fancyboxInner = $fancyboxSlide.find(".kim-gallery__fancybox-inner");

    if ($fancyboxImages.length) {
      $fancyboxImages.css('max-height', '');

      if (action === 'open') {
        var $fancyboxSlideContent = $fancyboxSlide.find(".kim-gallery__fancybox");

        if ($fancyboxSlideContent.length) {
          var fancyboxSlideHeight = $fancyboxSlide.height();
          var fancyboxSlideContentInnerHeight = $fancyboxSlideContent.innerHeight();

          if (fancyboxSlideContentInnerHeight > fancyboxSlideHeight) {
            var maxImageHeight = fancyboxSlideHeight;
            var $fancyboxDescription = $fancyboxSlide.find(".kim-gallery__fancybox-description");
            var $fancyboxMedia = $fancyboxSlide.find(".kim-gallery__fancybox-media");
            var stacked = false;

            if ($fancyboxDescription.length) {
              maxImageHeight = $fancyboxSlide.height() - $fancyboxDescription.innerHeight() - ($fancyboxSlideContent.innerHeight() - $fancyboxSlideContent.height());
            }

            if ($fancyboxImages.length === 1) {
              $fancyboxImages.css('max-height', (maxImageHeight - 10));
            } else {
              $fancyboxImages.each(function(){
                if (($(this).width() + 10) > Math.floor($fancyboxMedia.width()/2)) {
                  stacked = true;
                }
              });

              if (stacked) {
                if ($fancyboxMedia.hasClass('kim-gallery__fancybox-media--portrait')) {
                  maxImageHeight = maxImageHeight - 10;

                  var maxWidth = $fancyboxSlide.width() - ($fancyboxSlideContent.innerWidth() - $fancyboxSlideContent.width());
                  var ratioFirst = $fancyboxImages.first().width()/$fancyboxImages.first().height();
                  var ratioLast = $fancyboxImages.last().width()/$fancyboxImages.last().height();
                  var commonWidth = $fancyboxImages.first().width() + $fancyboxImages.last().width();
                  var maxCurrentHeight = $fancyboxImages.first().height();

                  ratioFirst = ratioFirst.toFixed(2);
                  ratioLast = ratioLast.toFixed(2);

                  if (maxCurrentHeight < $fancyboxImages.last().height()) {
                    maxCurrentHeight = $fancyboxImages.last().height();
                  }

                  while(((maxCurrentHeight >= Math.floor(maxImageHeight/2 - 20)) && (commonWidth >= (maxWidth - 20)))) {
                    maxCurrentHeight -= 1;
                    commonWidth = maxCurrentHeight*ratioFirst + maxCurrentHeight*ratioLast;
                    commonWidth = commonWidth.toFixed(2);
                  }

                  maxImageHeight = maxCurrentHeight - 5;
                } else {
                  maxImageHeight = Math.floor((maxImageHeight - 20)/2);
                }

                $fancyboxImages.css('max-height', maxImageHeight);
              } else {
                $fancyboxImages.css('max-height', (maxImageHeight - 10));
              }
            }
          }
        }

        if ($fancyboxInner.length) {
          $fancyboxInner.css('opacity', 1);
        }
      } else if ($fancyboxInner.length) {
        $fancyboxInner.css('opacity', '');
      }
    } else if ($fancyboxInner.length) {
      if (action === 'open') {
        $fancyboxInner.css('opacity', 1);
      } else {
        $fancyboxInner.css('opacity', '');
      }
    }
  }
}

function kimInitGallery() {
  var $galleries = $('.kim-gallery .kim-gallery__content-inner');
  var $galleryLargeImgs = $(".kim-gallery__item-img--fancybox");

  if ($galleryLargeImgs.length) {
    $galleryLargeImgs.lazyload();
  }

  if ($galleries.length) {
    $galleries.each( function(){
      var $this = $(this);
      var $arrowsBlock = $this.next(".kim-gallery__nav");
      var id = $this.closest(".kim-gallery").data("gallery-id");
      var $breakpoint = 0;

      $().fancybox({
        selector : '#kim-gallery--'+ id  +' .slick-slide:not(.slick-cloned) .kim-gallery__item-media',
        hash     : false,
        backFocus: false,
        baseClass: "fancybox-container--kim-gallery",
        afterShow: function(instance, current) {
          var $item_link = $('#kim-gallery--'+ id  +' .slick-slide .kim-gallery__item-media[data-src="'+ current.src +'"]');

          if ($item_link.length) {
            var $parentSlide = $item_link.closest(".slick-slide");

            if ($parentSlide.length) {
              $this.slick('slickGoTo', $parentSlide.data("slick-index"), true);
            }
          }

          kimResizeCurrentFancybox(current.src, 'open');
        },

        afterClose: function(instance, current){
          kimResizeCurrentFancybox(current.src, 'close');
        },
      });

      $kimWindow.on("resize", () => {
        $.fancybox.close(true);
      });

      $this.on('init', function(slick){
        if (slick.activeBreakpoint) {
          $breakpoint = slick.activeBreakpoint;
        } else {
          var screenWidth = windowWidth();

          if (screenWidth < 568) {
            $breakpoint = 0;
          } else if (screenWidth < 768) {
            $breakpoint = 568;
          } else {
            $breakpoint = 768;
          }
        }
      });

      $this.on('afterChange', function (event, slick, currentSlide) {

        if($this.find('.slick-slide.slick-current[data-slick-index="'+ currentSlide +'"]:last-child').length) {
          $('.kim-gallery__nav-button--next').addClass('kim-gallery__nav-button--hidden');
        }
        else {
          $('.kim-gallery__nav-button--next').removeClass('kim-gallery__nav-button--hidden');
        }

        if(currentSlide === 0) {
          $('.kim-gallery__nav-button--prev').addClass('kim-gallery__nav-button--hidden');
        }
        else {
          $('.kim-gallery__nav-button--prev').removeClass('kim-gallery__nav-button--hidden');
        }
      });

      $this.on('breakpoint', function(event, slick){
        var currentBreakpoint;

        if (slick.activeBreakpoint) {
          currentBreakpoint = slick.activeBreakpoint;
        } else {
          var screenWidth = windowWidth();

          if (screenWidth < 568) {
            currentBreakpoint = 0;
          } else if (screenWidth < 768) {
            currentBreakpoint = 568;
          } else {
            currentBreakpoint = 768;
          }
        }

        if (slick.activeBreakpoint !== $breakpoint) {
          var currentSlideNum = $this.slick('slickCurrentSlide');

          if (currentSlideNum && (currentBreakpoint > $breakpoint)) {
            if (($breakpoint === 0) && (currentBreakpoint === 568)) {
              currentSlideNum = Math.floor(currentSlideNum / 2);
            } else if (($breakpoint === 0) && (currentBreakpoint === 768)) {
              currentSlideNum = Math.floor(currentSlideNum / 4);
            } else if (($breakpoint === 568) && (currentBreakpoint === 768)) {
              currentSlideNum = Math.floor(currentSlideNum / 2);
            }

            if (currentSlideNum > slick.slideCount) {
              currentSlideNum = slick.slideCount;
            } else if (currentSlideNum < 0) {
              currentSlideNum = 0;
            }

            setTimeout(function(){
              $this.slick('slickGoTo', currentSlideNum, true);
            },1000);
          } else if (currentSlideNum && (currentBreakpoint < $breakpoint)) {
            if (($breakpoint === 768) && (currentBreakpoint === 568)) {
              currentSlideNum = (currentSlideNum * 2);
            } else if (($breakpoint === 768) && (currentBreakpoint === 0)) {
              currentSlideNum = currentSlideNum * 4;
            } else if (($breakpoint === 568) && (currentBreakpoint === 0)) {
              currentSlideNum = (currentSlideNum * 2);
            }

            if (currentSlideNum > slick.slideCount) {
              currentSlideNum = slick.slideCount;
            } else if (currentSlideNum < 0) {
              currentSlideNum = 0;
            }

            setTimeout(function(){
              $this.slick('slickGoTo', currentSlideNum, true);
            },1000);
          }

          $breakpoint = currentBreakpoint;
        }
      });

      kimInitGallerySlider($this, $arrowsBlock);
    });
  }
}

function kimInitScrollSpy() {
  var $topLinks= $('#kim-aside-links--top');
  var $leftLinks= $('#kim-aside-links--left');
  var $header = $("#header");
  var offset = 5;
  var screenWidth = windowWidth();

  if ($topLinks.length || $leftLinks.length) {
    if ($header.length) {
      offset = $header.innerHeight();
    }

    if ($topLinks.length && (screenWidth < 1200)) {
      $kimBody.scrollspy({
        target: '#kim-aside-links--top',
        offset: (offset + 5),
      });
    }

    if ($leftLinks.length && (screenWidth >= 1200)) {
      $kimBody.scrollspy({
        target: '#kim-aside-links--left',
        offset: (offset + 5),
      });
    }

    $kimWindow.on('load resize', () => {
      var currentScreenWidth = windowWidth();

      if (((screenWidth < 1200) && (currentScreenWidth >= 1200)) || ((screenWidth >= 1200) && (currentScreenWidth < 1200))) {
        $kimBody.scrollspy('dispose');

        if ($header.length) {
          offset = $header.innerHeight();
        }

        if ((currentScreenWidth >= 1200) && $leftLinks.length) {
          $kimBody.scrollspy({
            target: '#kim-aside-links--left',
            offset: (offset + 5),
          });
        } else if ($topLinks.length) {
          $kimBody.scrollspy({
            target: '#kim-aside-links--top',
            offset: (offset + 5),
          });
        }
      } else if ($header.length) {
        var currentOffset = $header.innerHeight();

        if (currentOffset !== offset) {
          $kimBody.scrollspy('dispose');
        }

        if ((currentScreenWidth >= 1200) && $leftLinks.length) {
          $kimBody.scrollspy({
            target: '#kim-aside-links--left',
            offset: (currentOffset + 5),
          });
        } else if ($topLinks.length) {
          $kimBody.scrollspy({
            target: '#kim-aside-links--top',
            offset: (currentOffset + 5),
          });
        }

        offset = currentOffset;
      }

      screenWidth = currentScreenWidth;
    });

    // $kimWindow.on('activate.bs.scrollspy', function () {
    //   var $anchor = $(event.target).find('a');
    //
    //   if ($anchor.length) {
    //     var $menu = $anchor.closest('.kim-aside-links');
    //
    //     if ($menu.length) {
    //       var $activeLinks = $menu.find('.kim-aside-links__link--active');
    //
    //       if ($activeLinks.length) {
    //         $activeLinks.removeClass('kim-aside-links__link--active');
    //       }
    //     }
    //
    //     $anchor.addClass('kim-aside-links__link--active');
    //   }
    // });
  }
}

function kimInitContentImagesFancybox() {
  var $contentLinkedImages = $(".kim-article__section--content a img");

  if ($contentLinkedImages.length) {
    $contentLinkedImages.each(function(){
      var $link = $(this).closest("a");
      var target = $link.attr("target");

      if (!target || (target === "_self")) {
        $link.fancybox();
      }
    });
  }
}

function kimSetCopyrightYear() {
  var $yearElement = $(".kim-copyright__year");

  if ($yearElement.length) {
    var currentDate = new Date();

    $yearElement.html(currentDate.getFullYear());
  }
}

function kimSetFooterPosition($footer) {
  var freeDistance =
    windowHeight() - $footer.position().top - $footer.innerHeight();

  if (freeDistance > 0) {
    $footer.css({ "margin-top": freeDistance + "px" });
  }
}

function kimPlaceTheFooter() {
  var $footer = $("#footer");

  if ($footer.length) {
    kimSetFooterPosition($footer);

    $(window).on("load resize", () => {
      kimSetFooterPosition($footer);
    });
  }
}

function Scrolldown() {
  window.scroll(0,0);
}

function kimDetectURL() {
  if ( window.location.hash ) {
    Scrolldown();

    $(document).ready(function () {
      Scrolldown();
    });

    $(window).on('load', function(){
      Scrolldown();

      var additionalOffset = 0;
      var $tabLinkToOpen = $('.nav-tabs li a[href="' + window.location.hash + '"]');
      var $header = $("#header");

      if ($header.length) {
        additionalOffset -= $header.innerHeight();
      }

      if ( $tabLinkToOpen && $tabLinkToOpen.length ) {
        var $tabsBlock = $tabLinkToOpen.closest('.nav-tabs');

        $tabLinkToOpen.tab('show');

        if ($tabsBlock.length > 0) {
          $("html, body").animate({scrollTop: ($tabsBlock.offset().top + additionalOffset)}, 700);
        }
      }
      else {
        var $scrollTarget = $(window.location.hash);

        if ($scrollTarget && $scrollTarget.length) {
          $("html, body").animate({scrollTop: ($scrollTarget.offset().top + additionalOffset)}, 700);
        }
      }
    });
  }
}

function isElementInViewport(el) {
  if (typeof jQuery === "function" && el instanceof jQuery) el = el[0];

  var rect = el.getBoundingClientRect();
  var headerHeight = 0;
  var $header = $("#header");

  if ($header.length) {
    headerHeight = $header.height();
  }

  return (
    (rect.top >= headerHeight && rect.top <= (window.innerHeight || document.documentElement.clientHeight))
    || (rect.bottom >= headerHeight && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
    || (rect.top <= headerHeight && rect.bottom >= (window.innerHeight || document.documentElement.clientHeight))
  );
}

function kimContactForm() {
  var $videos = $(".kim-contact-form__video");

  if ($videos.length) {
    $kimWindow.on("load resize scroll", () => {
      $videos.each(function(){
        var $video = $(this);

        if (isElementInViewport($video.parent())) {
          $video[0].play();
        } else {
          $video[0].pause();
        }
      });
    });
  }

  $kimDocument.on("click", "#contactSendButton", function(){
    var $submit = $(this);
    var $form = $submit.closest("form");
    var $formWrapper = $submit.closest(".kim-contact-form__content");
    var $header = $("#header");
    var additionalOffset = 0;
    var $target = ($formWrapper.length ? $formWrapper : ($form.length ? $form : ''));

    if ($header.length) {
      additionalOffset -= $header.innerHeight();
    }

    if ($target.length) {
      $("html, body").animate({ scrollTop: ($target.offset().top + additionalOffset)}, 700);
    }
  });
}

kimDetectURL();

jQuery(document).ready(() => {
  kimHandleButtonsFocus();
  kimHandleAnchorLinks();
  kimGetScrollWidth();
  kimFixPlaceholders();
  kimFixFrames();
  kimContactForm();
  kimInitNavigation();
  kimInitSlider();
  kimInitGallery();
  kimInitScrollSpy();
  kimInitContentImagesFancybox();
  kimSetCopyrightYear();
  kimPlaceTheFooter();
});



// WEBPACK FOOTER //
// ./scripts/main.js